import Vue from 'vue'
import Router from 'vue-router'
import DashboardSummary from '@/components/dashboard/Dashboard.vue'
import DashboardKeywords from '@/components/dashboard/Keywords.vue'
import DashboardEngagement from '@/components/dashboard/Engagement.vue'
import KeywordChannel from '@/components/keyword/KeywordChannels.vue'
import Facilities from '@/components/facilities/Facilities.vue'
import FacilityRecord from '@/components/facilities/FacilityRecord.vue'
import CreateAdmin from '@/components/dashboard/CreateAdmin.vue'
import CostStatistics from '@/components/cost-acquisition/Statistics.vue'
import Channel from '@/components/cost-acquisition/Channel.vue'
import Report from '@/components/cost-acquisition/Report.vue'
import CreateSmsApp from '@/components/CreateSmsApp/index.vue'
import ViewApps from '@/components/CreateSmsApp/view.vue'
import Login from '@/components/Login.vue'
import Callback from '@/components/callback.vue'
import Menu from '@/components/menu/index.vue'
import { requireAuth } from '../../utils/auth'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback
    },
    {
      path: '/summary',
      name: 'summary',
      beforeEnter: requireAuth,
      component: DashboardSummary
    },
    {
      path: '/keywords',
      name: 'keywords',
      beforeEnter: requireAuth,
      component: DashboardKeywords
    },
    {
      path: '/engagement',
      name: 'engagement',
      beforeEnter: requireAuth,
      component: DashboardEngagement
    },
    {
      path: '/channels',
      name: 'channels',
      beforeEnter: requireAuth,
      component: KeywordChannel
    },
    {
      path: '/facilities',
      name: 'facilities',
      beforeEnter: requireAuth,
      component: Facilities
    },
    {
      path: '/facilities/:facilityId',
      name: 'facilitiesRecord',
      beforeEnter: requireAuth,
      component: FacilityRecord
    },
    {
      path: '/createadmin',
      name: 'CreateAdmin',
      beforeEnter: requireAuth,
      component: CreateAdmin
    },
    {
      path: '/channel',
      beforeEnter: requireAuth,
      component: Channel
    },
    {
      path: '/report',
      beforeEnter: requireAuth,
      component: Report
    },
    {
      path: '/view-statistics',
      beforeEnter: requireAuth,
      component: CostStatistics
    },
    {
      path: '/new',
      beforeEnter: requireAuth,
      component: CreateSmsApp
    },
    {
      path: '/apps',
      beforeEnter: requireAuth,
      component: ViewApps
    },
    {
      path: '/menu',
      beforeEnter: requireAuth,
      component: Menu
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js